import React from 'react'
import { Link } from 'react-router-dom'

const User = props => {
    let isMobileMode = (props.mode == 'mobile')
        return <li role="presentation"
            className={isMobileMode ? "dropdown isMobileMode menu-item hidden-sm hidden-md hidden-lg" : "dropdown"}>
                <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    <span className="header-nav-text">
                        <span style={{padding: '0 1rem 0 0'}}>
                            <i className="fa fa-sign-out" />
                        </span>
                        {props.email}
                        {!isMobileMode ? <span className="caret"/> : null}
                    </span>
                </a>
                <ul className="dropdown-menu">
                    <li><i className="fas fa-sign-out-alt"></i><Link to="/logout">Logout</Link></li>
                </ul>
        </li>
}

export default User;